

/* sync function */

export function setErrorSecurity(title, message){
	return {
		type: 'SET_ERROR_SECURITY',
		data: {
			title: title,
			message: message
		},
	}
}




// WEBPACK FOOTER //
// ./app/actions/errorSecurity.js